import React from 'react'
import 'antd/dist/antd.css';
import { Card } from 'antd';
import headerImage from './headerImage.png'
import HeaderDetails from './HeaderDetails';
import "antd/dist/antd.css";
import { Row} from "antd";


export default function Top({fullName,phoneNumber,mailId}) {

  return (
    <Row style={{backgroundColor:"#6C63FF",
    padding:16,
  }}>
      <Card style={{"backgroundColor":"#FFFFFF",
      width:"100%",
      borderRadius:"10px",
     }}>
     
    
    <HeaderDetails
      icon={headerImage}
      designation="Business owner"
      name={fullName}
      // mobileNumber={phoneNumber}
      mailId={mailId}
    /> 
  
  </Card> 
  </Row>
  )
}

